const equipmentEndpoints = {
  EQUIPMENT_DRAFT: 'loopay-equipment-management/equipment',
  PRESIGNED_URLS_BATCH: 'loopay-media-management/media/presigned-urls/batch',
  LIST_EQUIPMENT: (clientId: string, facilityId: string): string =>
    `loopay-equipment-management/clients/${clientId}/facilities/${facilityId}/equipment`,
  EDIT_EQUIPMENT: (id: string): string =>
    `loopay-equipment-management/equipment/${id}`,
  LIST_CATEGORIES: 'loopay-equipment-management/equipment/categories',
};

export default equipmentEndpoints;
